module.exports = __webpack_public_path__ + "static/media/aura.11d91566.jpeg";